export { Spinner } from './spinner';
export type { ISpinnerProps } from './spinnder.interface';
